module.exports = __webpack_public_path__ + "static/OpenSource-86ba9753ab8de905dfe4d2b0127d78d2.jpg";